<template>
  <div class="jin-play-box tv-video">
    <div  class="jin-play-box__h">
      <div class="jin-play-box__l">
        <live-staus-tag
          :preview="hasPreviewVideo"
          :repeat="isPlayingRepeat"
          :live="isLive"
        />
        <h3 class="jin-play-box__title">{{ customTitle || title }}</h3>
      </div>
      <div class="jin-play-box__r">
        <el-popover
            ref="phoneSharePopover"
            trigger="hover"
            placement="bottom-end"
            popper-class="glass-popover glass-effect is-black"
            :visible-arrow="false"
            @show="onPopoverShow('phoneSharePopover')"
          >
            <div style="padding: 16px">
              <img
                style="border-radius: 4px;"
                  width="120"
                  v-if="liveType === 'tradingNew'"
                  src="../../../assets/img/trading_qrcode.png"
                />
              <img style="border-radius: 4px;" width="120" v-else src="../../../assets/img/tv_qrcode.png" />
              <div style="
              margin-top: 8px;
              text-align: center;
              font-size: 14px;
              font-weight: bold;
              color: var(--on-surface);
              user-select: none;
              ">
              <div style="line-height: normal;">
                扫描右侧二维码
                <br>
                畅享手机看直播
              </div>
              </div>
            </div>

            <div slot="reference" class="jin-play-box__btn jin-play-box__phone" style="color: var(--on-surface);">
              <PhoneSvg :size="32" />
            </div>
          </el-popover>
        <!-- <span v-if="showRoomOnlineCount">在线人数: {{currentRoomOnlineCount}}</span> -->

        <!-- <jin-popover
          ref="qrcodePopover"
          popper-class="jin-qrcode-popover"
          placement="bottom-end"
          :open-delay="300"
          trigger="hover"
        >
          <div class="jin-qrcode">

            <dl>
              <dt>
                <p>扫描右侧二维码</p>
                <p>畅享手机看直播</p>
              </dt>
              <dd>
                <img
                  v-if="liveType === 'tradingNew'"
                  src="../../../assets/img/trading_qrcode.png"
                />
                <img v-else src="../../../assets/img/tv_qrcode.png" />
              </dd>
            </dl>
          </div>
        </jin-popover>
        <div
          v-popover:qrcodePopover
          class="jin-play-box__btn jin-play-box__phone"
        >
          <icon type="phone"></icon>
        </div> -->
      </div>
    </div>
    <div class="tv-video__b">
      <!-- 试看标识 -->
      <template v-if="(isTrySee || (isRepeatTrySee && isPlayingRepeat))">
        <template v-if="isLive ? !isTrySeeEnd : !isRepeatTrySeeEnd">
          <template v-if="isMobile">
            <div
              @click="toVipPage"
              class="try-free-tips"
              :class="{
                'svip-only': liveRoleType === LIVE_ROLE_TYPE.svip || repeatRoleType === LIVE_ROLE_TYPE.svip,
                'vip-only': liveRoleType === LIVE_ROLE_TYPE.vip || repeatRoleType === LIVE_ROLE_TYPE.vip,
              }">
              此为试看版，<span>购买</span><div class="logo"></div> 观看完整版
            </div>
            <div
              @click="toVipPage"
              class="try-free-top" :class="{
                'svip': liveRoleType === LIVE_ROLE_TYPE.svip || repeatRoleType === LIVE_ROLE_TYPE.svip,
                'vip': liveRoleType === LIVE_ROLE_TYPE.vip || repeatRoleType === LIVE_ROLE_TYPE.vip,
                'is-mobile': isMobile
              }"></div>
          </template>

        </template>
      <!-- 试看结束 -->
        <template v-else>
          <div class="try-see-end">
            <p>该{{isLive ? '直播' : '视频'}}为VIP{{isLive ? '直播' : '重播'}}，试看已结束</p>
            <button @click="toVipPage">立即成为VIP</button>
          </div>
        </template>
      </template>

      <!-- 当repeatImageUrl没值表示不是重播 -->
      <template v-if="!repeatImageUrl">
        <!-- 直播 -->
        <template v-if="liveUrl">
          <template v-if="liveUrl">
            <div class="tv-video__box" v-if="isMobile">
              <video
                id="J_tv_video"
                width="100%"
                height="100%"
                controls="controls"
                webkit-playsinline
                playsinline
                x-webkit-airplay="allow"
                x5-playsinline
                autoplay="autoplay"
              ></video>
            </div>
            <div v-else class="tv-video__box" id="J_tv_box"></div>
          </template>
          <img class="tv-video__poster live" v-else :src="poster">
        </template>

        <!-- 预告视频 -->
        <div v-else-if="hasPreviewVideo">
          <div class="tv-video__box" v-if="isMobile">
            <video
              id="J_tv_video"
              width="100%"
              height="100%"
              controls="controls"
              webkit-playsinline
              playsinline
              x-webkit-airplay="allow"
              x5-playsinline
              autoplay="autoplay"
            ></video>
          </div>
          <div v-else class="tv-video__box preview" id="J_tv_box"></div>
        </div>

        <!-- 预告封面 -->
        <div
          v-else
          class="tv-video__poster preview"
          @click="() => { isTradingPageAndNotAVip && toVipPage() }"
          :class="{
            trading: isTradingPageAndNotAVip
          }">
          <img :src="posterUrl" />
        </div>
      </template>
      <!-- 表示重播 -->
      <div
        v-else
        class="tv-video__poster repeat"
        :class="{
          trading: isTradingPageAndNotAVip
        }"
        >
        <img :src="repeatImageUrl" />
        <a
          v-if="repeatImageUrl && isTradingPageAndNotAVip"
          class="tv-video__vip-link"
          @click="toVipPage"
          href="javascript:;"
        ></a>
        <glass-btn round type="default" @click="showRepeat" >
          <PlayLineSvg  />
          <span>点击这里收看最近一期节目</span>
        </glass-btn>

      </div>
      <div v-if="isShowNextTV && false" class="tv-video__mask">
        <div class="tv-video-tips">
          <h4 class="tv-video-tips__h">
            温馨提示：{{ nowDatas.prevue.title }}即将直播
          </h4>
          <div class="tv-video-tips__b">
            <jin-button @click="closeNextTV">关闭</jin-button>
            <jin-button type="primary" @click="showNextTV">提前进入</jin-button>
          </div>
        </div>
      </div>
    </div>
    <div class="tv-video__f">
      <div class="tv-video__l">
        <div class="tv-video-info">
          <img
            v-if="getEmceeInfo('pic')"
            class="tv-video-info__avatar"
            :src="getEmceeInfo('pic')"
            alt=""
          />
          <span v-if="getEmceeInfo('nick')" class="tv-video-info__text"
            >{{ getEmceeInfo('nick') }}</span
          >
          <el-popover
            v-if="wechatUrl"
            ref="weixinFollowPopover"
            trigger="hover"
            placement="top"
            popper-class="glass-popover glass-effect is-black"
            :visible-arrow="false"
            @show="onPopoverShow('weixinFollowPopover')"
          >
          <div style="padding: 16px">
            <img style="border-radius: 4px;" width="120" :src="wechatUrl" alt="" />
            <div style="
            margin-top: 8px;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            color: var(--on-surface);
            user-select: none;
            ">微信扫一扫关注</div>
          </div>
            <div slot="reference" class="tv-video-info__btn" v-glass="{type: 'btnNormal'}">
              <WeixinSvg />
            </div>
          </el-popover>
          <a
            class="tv-video-info__btn is-weibo"
            target="_blank"
            :href="getEmceeInfo('weibo')"
            v-if="getEmceeInfo('weibo')"
            v-glass="{type: 'btnNormal'}"
          >
            <WeiboSvg />
            <!-- <icon type="weibo"></icon> -->
          </a>
          <base-divider
            v-if="wechatUrl || getEmceeInfo('weibo')"
          />
          <!-- <jin-popover ref="wechatPopover" placement="right" trigger="hover">
            <img width="200" :src="wechatUrl" alt="" />
          </jin-popover>
          <p v-popover:wechatPopover class="tv-video-info__btn is-wechat">
            <icon v-if="wechatUrl" type="wechat"></icon>
          </p> -->
          <div
            class="tv-video-info__attention"
            :class="{'is-follow' : follow}"
            @click="onAttend"
            v-glass="{ type: 'btnNormal' }"
          >
            <PlusSvg v-if="!follow"></PlusSvg>
            {{follow ? '已关注' : '关注'}}
          </div>
        </div>
      </div>
      <div class="tv-video-share">
        <div class="tv-video-share__label">
          <ShareSvg />
          分享：
        </div>
        <div class="tv-video-share__btn-group">
          <a class="tv-video-share__btn" target="_blank" href="https://connect.qq.com/widget/shareqq/index.html?url=https%3A%2F%2Ftv.jin10.com%2F%23%2F&title=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&source=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&desc=%E9%87%91%E5%8D%81TV%E6%89%BF%E8%BD%BD%E7%9B%B4%E6%92%AD%E8%8A%82%E7%9B%AE%EF%BC%8C%E5%AE%9E%E6%97%B6%E7%95%99%E8%A8%80%E4%BA%92%E5%8A%A8%E3%80%82%E5%9C%A8TV%E9%A1%B5%E9%9D%A2%E6%82%A8%E5%B0%86%E7%AC%AC%E4%B8%80%E6%97%B6%E9%97%B4%E8%A7%82%E7%9C%8B%E5%88%B0%E9%87%91%E5%8D%81%E6%97%A9%E7%9F%A5%E9%81%93%E3%80%81%E7%8E%AF%E7%90%83%E8%BE%9B%E8%AF%B4%E3%80%81%E9%87%91%E5%8D%81%E5%90%8C%E4%BC%A0%E5%A3%B0%E8%AF%91%E7%AD%89%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD%EF%BC%8C%E9%94%81%E5%AE%9A%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD%E9%A2%84%E5%91%8A%EF%BC%8C%E8%8E%B7%E5%8F%96%E5%B9%B2%E8%B4%A7%E5%88%86%E7%A7%92%E5%BF%85%E4%BA%89%E3%80%82&pics=https%3A%2F%2Fimages.jin10.com%2Favatar%2F8dfe8fb5-01ff-48c2-a824-2f43677d9548.png%2Flite">
            <QqSvg />
          </a>
          <a class="tv-video-share__btn" target="_blank" href="http://service.weibo.com/share/share.php?url=https%3A%2F%2Ftv.jin10.com%2F%23%2F&title=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&pic=https%3A%2F%2Fimages.jin10.com%2Favatar%2F8dfe8fb5-01ff-48c2-a824-2f43677d9548.png%2Flite&appkey=">
            <WeiboSlimSvg :size="24" />
          </a>
          <el-popover
            ref="weixinSharePopover"
            trigger="hover"
            placement="top"
            popper-class="glass-popover glass-effect is-black"
            :visible-arrow="false"
            @show="onPopoverShow('weixinSharePopover')"
          >
            <div style="padding: 16px">
              <WexinShareQrcode />
              <div style="
              margin-top: 8px;
              text-align: center;
              font-size: 14px;
              font-weight: bold;
              color: var(--on-surface);
              user-select: none;
              ">微信扫一扫分享</div>
            </div>

            <div slot="reference" class="tv-video-share__btn">
              <WeixinSlimSvg :size="24" />
            </div>
          </el-popover>
          <!-- <share-button  dir="vertical"></share-button> -->
        </div>
      </div>
    </div>
    <vip-dialog v-model="showVipDialog"></vip-dialog>
  </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex'
import {fetch} from '@/commons/fetch'
import {isProduction, requestAttendUrl} from '@/commons/config'
import {device} from '@/commons'
import VipDialog from './VipDialog'
import mixins from './video.mixin'
import { on } from '@/commons/dom'
import LiveStausTag from '@/components/LiveStausTag'
import { BusEvent, LIVE_ROLE_TYPE, StorageKey } from '@/commons/constants'
// import { getUUID } from '@/apis'
import QualitySwitchButton from '@/plugins/videojs/quality-switch-button'
import ReloadButton from '@/components/ReloadButton/index'
import { jin10Behavior } from '@/commons/utils'
import PlusSvg from '@/components/Icon/PlusSvg.vue'
import WeiboSvg from '@/components/Icon/WeiboSvg.vue'
import WeixinSvg from '@/components/Icon/WeixinSvg.vue'
import QqSvg from '@/components/Icon/QqSvg.vue'
import ShareSvg from '@/components/Icon/ShareSvg.vue'
import WeiboSlimSvg from '@/components/Icon/WeiboSlimSvg.vue'
import WeixinSlimSvg from '@/components/Icon/WeixinSlimSvg.vue'
import WexinShareQrcode from '@/components/WexinShareQrcode.vue'
import bindGlassEffectMixin from '@/mixins/bindGlassEffectMixin'
import PhoneSvg from '@/components/Icon/PhoneSvg.vue'
import PlayLineSvg from '@/components/Icon/PlayLineSvg.vue'

/* eslint-disable */


// alert(isIpad)
// console.log(isIpad)
// let tradeCollegeType='tradeCollege'
export default {
  name: '',
  mixins: [mixins, bindGlassEffectMixin({multiple: true})],
  components: {
    VipDialog,
    LiveStausTag,
    PlusSvg,
    WeiboSvg,
    WeixinSvg,
    QqSvg,
    ShareSvg,
    WeiboSlimSvg,
    WeixinSlimSvg,
    WexinShareQrcode,
    PhoneSvg,
    PlayLineSvg
  },
  computed: {
    ...mapGetters([
      'options',
      'liveInfo',
      'liveUrl',
      'liveType',
      'isLive',
      'isMobile',
      'serverTime',
      'posterUrl',
      'emcee',
      'videoID',
      'user',
      'isLogin'
    ]),
    ...mapState([
      'pageType',
      'isEliteVip',
      'isVip',
      'isBlackGoldVip',
      'isYearVip',
      'isSuperVip',
      'hasGetUser',
      'serviceQRCodeConfig',
      'topNavs',
      'chatRooms',
      'hasGetOptions'
      // 'trySeeRemain',
    ]),
    poster: {
      get() {
        return this.posterUrl;
      },
      set(v) {
        this.$store.dispatch('setPosterUrl', v);
      },
    },
    title() {
      return (
        (this.$route.meta && this.$route.meta.subTitle) ||
        (this.liveInfo && this.liveInfo.title )||
        (this.liveInfo && this.liveInfo.customTitle)
      );
    },

    wechatUrl() {
      return this.wechatQRCode
      // return this.getEmceeInfo('wechat');
    },
    wechatQRCode() {
      const { serviceQRCodeConfig, emcee, liveType } = this
      const getConfig = (key) => {
        const config = serviceQRCodeConfig.find(it => it.key === key)
        return config
      }
      const data = emcee ? getConfig(emcee) : getConfig(liveType)
      return data && data.qrcode && data.qrcode.length
        ? data.qrcode[0]
        : ''

    },
    isTradingPageAndNotAVip() {
      return !this.isVip &&  (this.pageType === 'tradingNew') && !this.options.tradingVideoFree;
    },
    isTradingLiveAndNotVip() {
      return !this.isVip && this.liveType === 'tradingNew' && !this.options.tradingVideoFree;
    },
    isUseM3u8() {
      return this.isMobile || device.isIpad;
    },
    isTradingPage() {
      return this.pageType === 'tradingNew'
    },
    showRoomOnlineCount() {
      return (this.pageType === 'live-d80' || this.liveType === 'live-d80')
        && [2334976, 7194486].includes(this.user.id)
    },
    currentRoomOnlineCount() {
      if(this.chatRooms && Object.keys(this.chatRooms).length) {
        const liveD80 = this.chatRooms[36]
        if(liveD80) {
          return liveD80.count
        }
      }
      return 0
    }
  },
  data() {
    return {
      LIVE_ROLE_TYPE,
      tv: null,
      isLoading: false,
      isShowNextTV: false,
      isCloseNextTV: false,
      nowDatas: {},
      nowData: {},
      monitorID: '',
      timeRange: 30 * 60 * 1000,
      repeatUrl: '',
      repeatImageUrl: '',
      player: null,
      customTitle: '',
      waitingTimer: null,
      curUrl: '',
      showVipDialog: false,
      follow: false,
      /** 是否含有预告视频 */
      hasPreviewVideo: false,
      isPlayingRepeat: false,
      isPlayingRepeatVideo: false,
      isTrySee: false,
      liveRoleType: 0,
      liveId: 0,
      trySeeTimer: null,
      isTrySeeEnd: false,
      repeatTrySeeMax: 5 * 60,
      isRepeatTrySee: false,
      repeatRoleType: 0,
      isRepeatTrySeeEnd: false,
      isRepeat: false,
      trySeeRemain: 0,

      qualityList: [],
      activeQuality: localStorage.getItem(StorageKey.LIVE_QUAILITY) ,

      isFullscreen: false,
    };
  },
  watch: {
    $route(to, from) {
      console.log('route--->', to);
      this.refreshLiveInfo(to)
    },
    customTitle() {
      document.title = this.customTitle || this.title;
    },
    liveUrl(v) {
      if (v) {
        // 有url且不是直播的话，说明是重播
        if (this.isLive) {
          // 在vip直播页且不是vip的话不给直播
          // if (this.isTradingPageAndNotAVip) {
          //   return false;
          // }
          this.repeatUrl = '';
          this.repeatImageUrl = '';
          this.$nextTick(() => {
            this.loadVideo(v);
          });
        } else {
          this.repeatUrl = v;
          console.log('setRepeatImageUrl ---');
          this.setRepeatImageUrl(this.options[this.liveType].repeatImage);
        }
      } else {
        // 监听liveUrl如果为空的话，只有是下发了showImage才会触发
        this.repeatUrl = '';
        this.repeatImageUrl = '';
        this.disposePlayer();
        this.clearWaitingTimer();
      }
    },
    monitorID(v, oldVal) {
      if (v) {
        // this.$socket.connection.then((socket) => {
        //   socket.emit('s', v);
        // });
      }
    },
    serverTime(v) {
      this.showNextTVTips(v);
    },

    repeatUrl(url) {
      console.log('repeatUrl change', url);
    },
    // trySeeRemain(val) {
    //   console.log('trySeeRemain', val);
    // },
    // user(v) {
    //   console.log('user -->', v);
    //   if(this.pageType === 'tradingNew') {
    //     this.init()
    //   }
    //   if(this.isTradingPageAndNotAVip) {
    //     this.showVipDialog = true
    //   }
    // },
    hasGetUser: {
      immediate: true,
      handler(val) {
        if(val) {
          this.init()
           if(this.isTradingPageAndNotAVip) {
            this.showVipDialog = true
          }
        }
      }
    }
  },

  created() {
    // if (this.pageType !== 'vip') {
      // this.init();
    // }


    // console.log(device.isIpad)
    // this.$socket.connection.then((socket) => {
    //   let eventName = 'runJs';
    //   if (location.href.indexOf('/testing/') !== -1) {
    //     eventName = 'runJsTest';
    //   }
    //   socket.on(eventName, this.onSocketData);
    // });
    this.$bus.$on(BusEvent.REFRESH_LIVE_INFO, () => {
      console.log('REFRESH_LIVE_INFO');
      this.refreshLiveInfo()
    })
  },
  methods: {
    init() {
      let tradeCollegeType = this.options.conflictProgram;
      this.$nextTick(() => {
        this.customTitle = '';
        let routerType = this.$route.meta.type || this.options.defaultType;
        this.getLiveShow(routerType).then(async (datas) => {
          // console.log('isLogin', this.isLogin);
          // console.log('datas',datas);

          let allDataTypes = ['live', 'prevue', 'repeat'];
          let nowData = null;
          for (let i = 0, l = allDataTypes.length; i < l; i++) {
            nowData = datas[allDataTypes[i]];
            if (Object.keys(nowData).length) {
              break;
            }
          }

          // let url = nowData.url;

          this.qualityList = nowData.url_tmpl || []
          if(this.qualityList.length) {
            this.activeQuality = this.activeQuality || this.qualityList[0].name
          }
          let type = nowData.type;
          let url = this.getCurrentQualityUrl()

          window._videoType =( type === tradeCollegeType ? '' : type) || this.options[routerType].roomID ;
          let isLive = !!datas.live.url;
          //TODO 取消测试代码
          // let isLive = true;

          let poster = '';
          let offline = datas.offline;
          let repeat = datas.repeat;
          let prevue = datas.prevue;
          let emcee = nowData.emcee;

          // 当有直播时，去直播的id

          //console.log('bb');
          let videoID = nowData.id;
          let tradingVideoID = videoID;
          // 获取统计id
          this.monitorID = nowData.monitor_id;
          console.log('isLive', isLive);
          if (isLive) {
            console.log('now data', nowData);
            url = this.getCurrentQualityUrl()

              // url = nowData.url;
            // if (this.isUseM3u8) {
            //   url = nowData.url;
            // } else {
            //   url = nowData.url_flv;
            // }
            this.setCustomTitle(datas.live);
            this.liveId = nowData.id
            this.repeatImageUrl = ''
            this.poster = this.isTradingPageAndNotAVip
              ? this.options.tradingNew.notVipImg || this.options.tradingNew.notVipImage
              : nowData.thumb
          } else {
            // 获取直播结束的时间，如果和当前时间相差30分钟，则显示回放图片
            if (
              this.compareTheTime(
                this.serverTime || new Date().getTime(),
                offline.live_end_time
              ) &&
              !offline.repeat_url
            ) {
              console.log('获取直播结束的时间，如果和当前时间相差30分钟，则显示回放图片');
              this.repeatImageUrl = ''
              type = offline.type || routerType;
              url = '';
              emcee = offline.emcee;
              console.log('type---> ', type);
              poster = offline.thumb || this.options[type].overImg;
              tradingVideoID = offline.id;
              this.setCustomTitle(offline);
            } else {
              // 无直播时优先去预告的id
              if (prevue.id) {
                tradingVideoID = prevue.id;
              } else {
                tradingVideoID = repeat.id;
              }

              // 如果不是直播，且预告和当前时间是在8小时外，也就是重播
              if (!this.compareTheTime(prevue.date, null, 8 * 60 * 60 * 1000)) {
                console.log('如果不是直播，且预告和当前时间是在8小时外，也就是重播');
                this.isRepeat = true
                type = repeat.type || routerType;
                emcee = repeat.emcee;
                url = repeat.repeat_url;
                videoID = repeat.id;
                this.repeatRoleType = repeat.is_vip
                if(this.getIsTrySeeType(repeat.is_vip)) {
                  this.isRepeatTrySee = true
                  this.repeatTrySeeMax = repeat.try_see * 60
                  //TODO TEST
                  // this.repeatTrySeeMax = 0.5 * 60
                }
                this.repeatUrl = url
                this.setRepeatImageUrl(this.options[type].repeatImage);
                this.setCustomTitle(repeat);
              } else {
                console.log('预告');
                emcee = prevue.emcee;
                url = '';
                this.repeatImageUrl = ''
                if(type === 'tradingNew' && this.isVip || type !== 'tradingNew') {
                  // console.log('prevue -->', prevue);
                  if(prevue.video_preview) {
                    this.hasPreviewVideo = true
                    this.$nextTick(() => {
                      this.loadVideo(prevue.video_preview)
                    })
                    //播放预告视频
                  }
                  poster = prevue.pre_cover ||  prevue.thumb
                }
                this.setCustomTitle(prevue);
              }
            }
          }

          this.$store.dispatch('setLiveState', isLive);
          this.$store.dispatch('setLiveType', type);
          this.$store.dispatch('setEmcee', emcee);
          this.$store.dispatch('setVideoID', videoID);
          this.$store.dispatch('setTradingVideoID', tradingVideoID);
          this.$store.dispatch('setChatReadyState', true);
          this.$store.dispatch('setPrevueTime', datas.prevue.date);

          this.getAttendCheck()

          this.resizeSide()

          if(isLive) {
            this.liveRoleType = nowData.is_vip
            if(this.getIsTrySeeType(nowData.is_vip)) {
              this.isTrySee = true

              // this.trySeeRemain = 10 * 1000
              this.trySeeRemain = nowData.try_see * 60 * 1000
              // const clientID = await getUUID()
              // console.log('clientID', clientID);
              // const uid = this.isLogin ? this.user.id : clientID
              // console.log('uid', uid);
              // const remainData = this.trySeeRemain[uid]
              // console.log('remainData', remainData);
              // if(!remainData) {
              //   this.$store.dispatch('setTrySeeRemain', {
              //     id: this.liveId,
              //     time: nowData.try_see * 60 * 1000,
              //     //TODO TEST
              //     // time: 30 * 1000,
              //     uid
              //   })
              // } else if(remainData && remainData[this.liveId] >= 0){
              //    this.$store.dispatch('setTrySeeRemain', {
              //     id: this.liveId,
              //     // time: nowData.try_see * 60 * 1000
              //     time: remainData[this.liveId],
              //     uid
              //   })
              // } else {
              //   this.isTrySeeEnd = true
              //   return

              // }
            }
          }




          //当前播放的类型为同声传译,且用户不是VIP,且该直播不免年费 -> 不显示直播
          // if (type === 'tradingNew' && this.isTradingPageAndNotAVip || this.isTradingLiveAndNotVip) {
          //   this.poster = poster || this.options.tradingNew.notVipImg ||this.options.tradingNew.notVipImage
          //   return false;
          // }
          if (!url) {
            // console.log('no url', poster);
            this.poster = poster || this.liveInfo.previewImg;
            return false;
          }
          this.$store.dispatch('setLiveUrl', url);
        })
        // .catch((err) => {
        //   console.error(err);
        // });
      })
    },
    refreshLiveInfo(to) {
      this.hasPreviewVideo = false
      this.isPlayingRepeat = false
      this.isTrySee = false
      this.isTrySeeEnd = false
      this.isRepeatTrySee = false
      this.isRepeatTrySeeEnd = false
      this.isFullscreen = false
      this.isRepeat = false
      clearTimeout(this.trySeeTimer)
      this.poster = ''
      if (this.liveUrl) {
        this.$store.dispatch('setLiveUrl', false);
      }
      if(to && to.meta.type === 'tradingNew' && !this.isVip && (!this.options.tradingVideoFree && this.hasGetOptions)) {
        this.showVipDialog = true
      }
      this.init();
    },
    filterData(res) {
      let tradeCollegeType = this.options.conflictProgram;
      let type = this.$route.meta.type || 'tv';

      let rebuildRes = {};

      let allDataTypes = ['live', 'prevue', 'repeat', 'offline'];
      allDataTypes.map((el) => {
        rebuildRes[el] = {repeatImage: ''};
      });
      for (let key in res) {
        let item = res[key];
        if (item && typeof item['type'] !== 'undefined') {
          if (item['type'] !== tradeCollegeType) {
            rebuildRes[key] = item;
          }
        } else {
          rebuildRes[key] = item;
        }
      }
      // console.log(rebuildRes)
      return res;
    },

    setCustomTitle(info) {
      // console.log('setCustomTitle', info);
      if (info && (info.title || info.room_name)) {
        this.customTitle = info.title || info.room_name;
      }
    },
    // 对比预告时间和当前时间，如果是在30分钟内返回true
    compareTheTime(endTime, startTime, timeRange = this.timeRange) {
      startTime = startTime || this.serverTime;
      startTime = this.timeTrans(startTime);
      endTime = this.timeTrans(endTime);
      const nowTime = startTime || new Date().getTime();
      const diffTime = endTime - nowTime;
      // 如果预告时间和当前时间差30分钟内
      if (diffTime > 0 && diffTime <= timeRange) {
        return true;
      }
      return false;
    },
    timeTrans(time) {
      if (typeof time === 'number') {
        time = time.toString().length < 13 ? time * 1000 : time;
      } else if (typeof time === 'string') {
        time = time.replace(/-/g, '/');
      }
      return new Date(time).getTime();
    },
    loadVideo(url) {
      /* 增加ipad 使用m3v8格式进行播放 */
      // if (this.isUseM3u8) {
      //   url = url.replace('.flv', '.m3u8');
      // } else {
      //   url = url.replace('.m3u8', '.flv');
      // }
      if (url.indexOf('https://') === -1) {
        url = url.replace('http:', 'https:');
      }

      console.log('living url:', url);
      this.curUrl = url;

      this.playVideo();
      if(this.isLive) {
        this.statistics();
      }
      this.closeNextTV();
    },
    disposePlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    },
    playVideo() {
      let tv = null;
      if (this.isMobile) {
        tv = document.querySelector('#J_tv_video');
        tv.src = this.curUrl;

        tv.addEventListener('play', () => {
          this.report()
        })

        on(tv, 'pause', () => {
          console.log('暂停: paused', tv.paused);
          this.stopLiveVideoTimer()
        })
        on(tv, 'ended', () => {
          this.stopLiveVideoTimer()
        })
        on(tv, 'enterpictureinpicture', () => {
          console.log('进入画中画模式');
          if(this.jsBridge.isApp) {
            this.jsBridge.dispatch('webClickPIPBtn')
          }
        })
        on(tv, 'timeupdate', () => {
          if(this.isRepeatTrySee && tv.currentTime > this.repeatTrySeeMax) {
          try {
            tv.currentTime = this.repeatTrySeeMax
            tv.pause()
            this.isRepeatTrySeeEnd = true
          } catch (error) {
            console.error(error);
          }
          // console.log('timeupdate', tv.currentTime);
        }
        })
        on(tv, 'leavepictureinpicture', (e) => {
          console.log('退出画中画模式');
          console.log('播放中', !tv.paused);
          if(this.jsBridge.isApp) {
            this.jsBridge.dispatch('h5PIPBtnAction', tv.paused ? '0' : '1')
          }
        })


        return false;
      }
      this.disposePlayer();
      const options = {
        mediaType: 'video',
        forceLive: this.isLive,
        sources: [this.curUrl],
        fluid: true,
        poster: this.posterUrl,
        // controls: !this.isRepeatTrySee,
        controls: true,
        autoplay: true,
        playsinline: true,
        controlBar: {
          remainingTimeDisplay: true,
        },
      };
      if (!this.isLive) {
        options.playbackRates = [1, 1.5, 1.75, 2];
      }
      // if (device.isIE) {
      //   options.techOrder = Jin10Player.techOrder.FLASH;
      // }
      this.player = Jin10Player('#J_tv_box', options, () => {
        // 如果需要把播放器的界面隐藏或者移走，请在此事件内操作
      // console.log('this.activeQuality', this.activeQuality);
        if(!this.isRepeat) {
          this.player.qualityMenu = new QualitySwitchButton(this.player, {
            label: this.activeQuality,
            onChange:(name) => {
              localStorage.setItem(StorageKey.LIVE_QUAILITY, name)
              const qualityItem = this.qualityList.find(it => it.name === name)
              if(qualityItem) {
                console.log('qualityItem.url', qualityItem.url);
                this.player.src(qualityItem.url)
                // this.$store.dispatch('setLiveUrl', qualityItem.url);
              }
            }
          })
        }
      if(this.isTrySee || this.isRepeatTrySee) {
        if(this.isRepeatTrySee) {
          this.liveRoleType = this.nowDatas.repeat.is_vip
        } else {
          this.liveRoleType = this.nowDatas.live.is_vip
        }
         let logoOptions = {
          image: this.liveRoleType === LIVE_ROLE_TYPE.svip
            ? 'https://tv.jin10.com/assets/img/open_elite_vip.png?v=2'
            : 'https://tv.jin10.com/assets/img/open_vip.png?v=2',
          url: this.liveRoleType === LIVE_ROLE_TYPE.svip
            ? 'https://www.jin10.com/vip/payment/index.html#/?tab=elite'
            : 'https://www.jin10.com/vip/payment/index.html',
          position: 'top-right',
          fadeDelay: null,
          width: 270,
          padding: 10,
        };
        let tryReadOption = {
          btnLink: this.liveRoleType === LIVE_ROLE_TYPE.svip
          ? 'https://www.jin10.com/vip/payment/index.html#/?tab=elite'
          : 'https://www.jin10.com/vip/payment/index.html',
          btnColor: this.liveRoleType === LIVE_ROLE_TYPE.svip ? '#EB4B43' : '#E4CE97',
          btnImage: this.liveRoleType === LIVE_ROLE_TYPE.svip
          ? 'https://cdn.jin10.com/assets/img/sites/video/elite_vip/vip_buy.png'
          : 'https://cdn.jin10.com/assets/img/sites/video/vip/vip_buy.png',
          fontSize: 14,
          btnImageWidth: 30,
          padding: '4px 10px',
          bottom: 40,
          left: 10,
          autoMinify: false
        }
        this.player.logo(logoOptions);

        this.player.tryread(tryReadOption);
      }
      this.clearWaitingTimer();
      });

      // console.log('qualityMenu', this.player.qualityMenu);

      this.playerEvents();
    },
    playerEvents() {
      window.player = this.player;
      this.player.on('play', () => {
        console.log('play');
        if(this.isTrySee) {
          //试看倒计时
          this.checkTrySeeLoop()
        }
        this.clearWaitingTimer();

        this.report()
      });
      this.player.on('pause', () => {
        console.log('pause');
        this.stopLiveVideoTimer()
      });
      this.player.on('ended', () => {
        console.log('ended');
        this.stopLiveVideoTimer()
        this.errorReplay();
        if(this.hasPreviewVideo) {
          //预告循环播放
          this.previewLoop()
        }
      });
      this.player.on('waiting', () => {
        console.log('waiting');
        this.errorReplay(15000);
      });
      this.player.on('ready', () => {
        // this.clearWaitingTimer()
        console.log('ready');
      });
      this.player.on('enterpictureinpicture', () => {
        console.log('画中画模式');
        this.jsBridge.dispatch('webClickPIPBtn')
      })
      this.player.on('timeupdate', () => {
        if(this.isRepeatTrySee && this.player.currentTime() > this.repeatTrySeeMax) {
          try {
            this.player.currentTime(this.repeatTrySeeMax)
            this.player.pause()
            this.player.exitFullscreen()
            this.isRepeatTrySeeEnd = true
          } catch (error) {
            console.error(error);
          }
          // console.log('timeupdate', this.player.currentTime());
        }
      })
      this.player.on('fullscreenchange', () => {
        this.isFullscreen = !this.isFullscreen
      })
      this.player.on('webkitfullscreenchange', () => {
        this.isFullscreen = !this.isFullscreen

      })
      this.player.on('error', (e) => {
        try {
          //源不支持
          const MEDIA_ERR_SRC_NOT_SUPPORTED = 4
          //解码失败
          const MEDIA_ERR_DECODE = 3

          console.error('[PLAY ERROR]:', this.player.error());
          const errorData = this.player.error()
          if([
            MEDIA_ERR_SRC_NOT_SUPPORTED,
            MEDIA_ERR_DECODE
          ].includes(errorData.code)) {
          const errorText = {
            [MEDIA_ERR_SRC_NOT_SUPPORTED]: '源视频格式错误或推流未开始',
            [MEDIA_ERR_DECODE]: '网络异常, 解码失败, 需检查推流',
          }[errorData.code]
          console.error('[PLAY ERROR]:', errorText);
            setTimeout(() => {
              const reloadBtnInstance = new ReloadButton()
              reloadBtnInstance.$mount()
              const wrapper = document.querySelector('.vjs-modal-dialog-content')
              ReloadButton(wrapper, {
                onClick:() => {
                  const name = '标清'
                  localStorage.setItem(StorageKey.LIVE_QUAILITY, name)
                  const qualityItem = this.qualityList.find(it => it.name === name)
                  if(qualityItem) {
                    this.player.src(qualityItem.url)
                  } else {
                    window.location.reload()
                  }
                }
              })
            }, 200);
          }
        } catch (error) {
          console.error(error);
        }
      })
    },
    clearWaitingTimer() {
      this.waitingTimer && clearInterval(this.waitingTimer);
    },
    previewLoop() {
      this.player.play()
    },
    errorReplay(t) {
      if (!this.isLive) {
        return false;
      }
      this.clearWaitingTimer();
      // this.waitingTimer = setInterval(() => {
      //   this.$tips({
      //     message: '网络出现波动，正在尝试重新加载',
      //     type: 'error',
      //   });
      //   // 如果有网络的情况下才执行replay方法
      //   const img = new Image();
      //   img.src = '//fm.jin10.com/assets/imgs/network-test.png';
      //   img.onload = () => {
      //     this.playVideo();
      //   };
      // }, t || 15000);
    },

    getLiveShow(type) {
      let params = type ? {type} : '';
      if(!isProduction) {
        params = params ? { ...params, test:'/testing/'  } : {  test:'/testing/'  }
      }
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        if (this.isTradingPageAndNotAVip) {
          const data = {
            live: {},
            offline: {},
            prevue: {},
            repeat: {},
          };
          this.nowDatas = data;
          this.isLoading = false;
          if(this.pageType !== 'tradingNew') {
            resolve(data);
            return false;
          }
        }
        fetch({
          type: 'GET',
          url: requestAttendUrl.now,
          params,
          headers: requestAttendUrl.headers,
          callback: () => {
            this.isLoading = false;
          },
          success: (res) => {
            this.nowDatas = this.filterData(res);
            resolve(this.filterData(res));
          },
          error: () => {
            this.isLoading = false;
            reject();
          },
        });
      });
    },
    onAttend() {
      let routerType = this.$route.meta.type || this.options.defaultType || window._videoType;
       const params = {
        room: routerType
      }
      let url = this.follow ? requestAttendUrl.cancel : requestAttendUrl.follow
      if(this.isLogin) {
        fetch({
          type: 'POST',
          url,
          params,
          headers: requestAttendUrl.headers,
          success: (res) => {
            // console.log(555, res)
            // this.nowDatas = this.filterData(res);
            // resolve(this.filterData(res));
            this.getAttendCheck()
          },

        });
      } else {
        this.showLogin()
      }
    },
    getAttendCheck() {
      let routerType = this.$route.meta.type || this.options.defaultType || window._videoType;
      const params = {
        room: routerType
      }

      fetch({
        type: 'GET',
        url: requestAttendUrl.check,
        params,
        headers: requestAttendUrl.headers,
        success: (res) => {
          this.follow = res.data.follow
          // this.nowDatas = this.filterData(res);
          // resolve(this.filterData(res));
        }
      });
    },
    onSocketData(code) {
      let ele = document.createElement('script');
      ele.innerHTML = code;
      document.body.appendChild(ele);
    },

    // 显示重播视频
    showRepeat() {
      if (!this.repeatUrl) {
        this.$tips({message: '暂时无回放视频'});
        return false;
      }
      this.repeatImageUrl = '';
      this.$nextTick(() => {
        this.loadVideo(this.repeatUrl);
        this.isPlayingRepeat = true
        this.repeatUrl = '';
      });
    },
    showNextTV() {
      let data = this.nowDatas.prevue;
      let type = data.type;
      let emcee =
        (type === 'tv' || type === 'fangtan') && !data.emcee
          ? 'Becca'
          : data.emcee;
      this.closeNextTV();
      this.poster = this.options[type].previewImg;
      this.$store.dispatch('setLiveUrl', '');
      this.$store.dispatch('setLiveType', type);
      this.$store.dispatch('setLiveState', false);
      // 设置主持人为预告里的主持人
      this.$store.dispatch('setEmcee', emcee);
    },
    closeNextTV() {
      if (!this.isShowNextTV) {
        return false;
      }
      this.isShowNextTV = false;
      this.isCloseNextTV = true;
    },
    showNextTVTips(serverTime) {
      if (this.posterUrl) {
        this.closeNextTV();
      }
      if (this.isCloseNextTV || this.isShowNextTV || this.posterUrl) {
        return false;
      }
      if (this.compareTheTime(this.nowDatas.prevue.date, serverTime)) {
        this.isShowNextTV = true;
      }
    },
    getEmceeInfo(key, obj) {
      let url = '';
      let emcee = this.emcee;
      let liveInfo = obj || this.liveInfo || {};
      let data = emcee ? liveInfo[emcee] : liveInfo;
      return data ? data[key] : '';
    },

    statistics() {
      let img = new Image();
      img.src = `https://tv-d.jin10.com/bg.png?t=${this.videoID}`;
    },

    __getCurrentItemRepeatImage() {},
    setRepeatImageUrl(url, info) {
      // console.log('setRepeatImageUrl');
      // console.log('url', url);
      // console.log('isTradingPageAndNotAVip -->', this.isTradingPageAndNotAVip)
      console.log(this.pageType, this.liveType)
      if (this.isTradingPageAndNotAVip) {
        this.repeatImageUrl =  this.options.tradingNew.notVipImg || this.options.tradingNew.notVipImage;
        return false;
      }
      this.repeatImageUrl = url;
    },
    toVipPage() {
      const url = this.liveRoleType === LIVE_ROLE_TYPE.svip
        ? 'https://www.jin10.com/vip_payment/index.html#/?tab=elite'
        : 'https://www.jin10.com/vip/payment/index.html'
      if (this.jsBridge.isApp) {
        this.jsBridge.dispatch('openAppWebViewWithNav', {url});
        return false;
      }
      // 只保留navs的name和type

      const columnName = this.pageType && this.topNavs.find(it => it.type === this.pageType)
      ? this.topNavs.find(it => it.type === this.pageType).name : '金十TV'

      jin10Behavior({
        pageName: 'tv直播页',
        module: `${columnName}|播放器`,
        action: '点击',
        type: '按钮',
        object: '购买',
        params: {
          live_name: document.title,
          btn_text: '立即成为VIP'
        }
      })
      window.open(url, '_blank');
    },
    resizeSide() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$bus.$emit('RESIZE_SIDE')
        }, 400)
      })
    },
    async checkTrySeeLoop() {
      const remain = this.trySeeRemain
      // const clientID = await getUUID()
      // const uid = this.isLogin ? this.user.id : clientID
      // const remain = this.trySeeRemain[uid][this.liveId]
      // console.log('checkTrySeeLoop remain', remain);
      if(remain >= 0) {
        this.trySeeRemain -= 1000
        // await this.$store.dispatch('setTrySeeRemain', {
        //     id: this.liveId,
        //     time: remain - 1000,
        //     uid
        //   }
        // )
        clearTimeout(this.trySeeTimer)
        this.trySeeTimer = setTimeout(() => {
          this.checkTrySeeLoop()
        }, 1000);
      } else {
        this.clearWaitingTimer()
         this.player.pause()
        //  this.player = null
         this.isTrySeeEnd = true
      }
    },
    getIsTrySeeType(videoRoleType) {
      console.log('videoRoleType', videoRoleType);
      console.log('isEliteVip', this.isEliteVip);
      let userLevel = LIVE_ROLE_TYPE.common
      if(this.isSuperVip || this.isBlackGoldVip || this.isYearVip) {
        userLevel = LIVE_ROLE_TYPE.yearVip
      } else if(this.isVip) {
        userLevel = LIVE_ROLE_TYPE.vip
      } else if(this.isEliteVip) {
        userLevel = LIVE_ROLE_TYPE.svip
      }
      console.log('userLevel', userLevel);
      if(userLevel < videoRoleType) {
        return true
      }
      return false
    },
    getCurrentQualityUrl() {
      const find = this.qualityList.find(it => it.name === this.activeQuality)
      // console.log('this.qualityList', this.qualityList);
      return find ? find.url : this.qualityList.slice(-1)[0] ? this.qualityList.slice(-1)[0].url : ''
    },
    showLogin () {
      if (this.jsBridge.isApp) {
        this.jsBridge.login()
      } else {
        this.$store.dispatch('showLogin')
      }
    },
    onPopoverShow(refName) {
      const el = this.$refs[refName].popperElm
      this.bindGlassEffect(el, {type: 'black'}, refName)
    }

  },
};
</script>


<style lang="scss" scoped>
.tv-video__poster {
  .glass-btn {
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    position: absolute !important;
    right: 10px;
    bottom: 15px;
    height: 45px;
    color: var(--on-input);
    font-size: 15px;
  }
}
.tv-video__poster.trading {
  cursor: pointer;
}
.try-free-tips {
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1000;
  bottom: 42px;
  left: 16px;
  padding: 0 8px;
  height: 24px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  .logo {
    width: 25px;
    height: 14px;
  }
  &.svip-only {
    span {
      color: #EB4B43;
    }
    .logo {

      background: url('../../../../../assets/img/svip_logo.png') no-repeat center / 100%;
    }
  }
  &.vip-only {
    span {
      color: #E4CE97;
    }
    .logo {
      background: url('../../../../../assets/img/vip_logo.png') no-repeat center / 100%;
    }
  }

}
.try-free-top {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
  width: 264px;
  height: 33px;
  cursor: pointer;
  &.svip {
    background: url('../../../../../assets/img/get_svip_tips.png') no-repeat center / 100%;;
  }
  &.vip {
    background: url('../../../../../assets/img/get_vip_tips.png') no-repeat center / 100%;;
  }
  &.is-mobile {
    width: 48px;
    height: 22px;
    &.svip {
      background: url('../../../../../assets/img/get_svip_tag.png') no-repeat center / 100%;
    }
    &.vip {
      background: url('../../../../../assets/img/get_vip_tag.png') no-repeat center / 100%;
    }
  }
}
.try-see-end {
  z-index: 1000;
  position: absolute;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  p {
    margin-bottom: 18px;
    font-size: 17px;
    color: #E5D9BC;
  }
  button {
    padding: 0 17px;
    height: 36px;
    background: #C59F6D;
    border-radius: 20px;
    color: #21232A;
    border: none;
    outline: none;
    cursor: pointer;
  }
}

// /deep/  {

//   .js-focus-visible .video-js :focus:not(.focus-visible),
//   .video-js .vjs-menu :focus:not(focus-visible),.video-js :focus:not(:focus-visible) {
//     background-color: #fff !important;
//   }
// }
</style>


<style lang="scss">
.dark {
  .tv-video__poster {
    opacity: .8;
  }
}
</style>



// WEBPACK FOOTER //
// video.vue?535477a1